import * as React from "react";

import GenCheckboxFilter from "../Gen/CheckboxFilter";
import GenControlsBar from "../Gen/ControlsBar";
import GenSearchBox from "../Gen/SearchBox";
import GenSelectFilter from "../Gen/SelectFilter";
import GenSortButtons from "../Gen/SortButtons";

interface DocumentListControlsProps {
  documents: ConnectedList<DocumentSnakeModel> | ConnectedList<GroupDocumentSnakeModel> | ConnectedList<DocumentSetDocumentRelationSnakeModel>;
}

export default function DocumentListControls(props: DocumentListControlsProps) {
  const {
    documents,
  } = props;

  return(
    <div>
      <GenControlsBar>
        <GenSearchBox
          {...documents}
          placeholder="Search by symptom, diagnosis, or case #..."
        />
        <GenCheckboxFilter
          {...documents}
          filterKey="extra_media"
          option={["ilike", "documents.description", "%extra_media%"]}
          label="Only cases with other media"
        />
        <div className="grow"/>
        <GenSortButtons
          {...documents}
          sortOptions={[
            {
              "title": "Case #",
              "value": "documents.id",
            },
            {
              "title": "Published",
              "value": "documents.created_at",
            },
          ]}
        />
      </GenControlsBar>
      <div className="gen-list-filter-panel">
        <GenSelectFilter
          {...documents}
          filterKey="Patient Age"
          label="Patient Age"
          options={[
            "Newborn",
            "Infant",
            "Toddler",
            "Child",
            "Adolescent",
            "Adult",
            "Young Adult",
            "Elderly",
          ]}
          filterGenerator={(option) => ["@>", "documents.mdata", {age_group: [option]}]}
        />
        <GenSelectFilter
          {...documents}
          filterKey="Organ System"
          label="Organ System"
          options={[
            "Circulatory",
            "Digestive",
            "Endocrine",
            "Integumentary/Dermatology",
            "Lymphatic",
            "Muscular",
            "Nervous",
            "Reproductive",
            "Respiratory",
            "Skeletal",
            "Urinary",
          ]}
          filterGenerator={(option) => ["@>", "documents.mdata", {organ_system: [option]}]}
        />
        <GenSelectFilter
          {...documents}
          filterKey="Specialty"
          label="Specialty"
          options={[
            "Dentistry",
            "Dermatology",
            "Emergency Medicine",
            "Family Medicine",
            "Internal Medicine",
            "Medical Genetics",
            "Neurosurgery",
            "Neurology",
            "Obstetrics & Gynecology",
            "Orthopedics",
            "Pathology",
            "Pediatrics",
            "Physical Medicine & Rehabilitation",
            "Psychiatry",
            "Surgery",
          ]}
          filterGenerator={(option) => ["@>", "documents.mdata", {specialty: [option]}]}
        />
        <GenSelectFilter
          {...documents}
          filterKey="Libraries"
          label="Libraries"
          options={[
            "Developing World Medicine",
            "Emergency Bedside Ultrasound",
            "Emergency Medical Services (EMS)",
            "Intro to Pathology",
            "Kartini Clinic For Children & Families: Eating Disorders Library",
            "Oregon Supported Living Program - Adults With Developmental Disabilities",
            "ReelDx Grand Rounds: Recorded Webinar Series",
          ]}
          filterGenerator={(option) => ["@>", "documents.mdata", {reeldx_libraries: [option]}]}
        />
      </div>
    </div>
  );
}
